angular.module('umFormViewer').constant('rowRepeaterRowListComparisonResultConstant', {
    EQUAL: 'equal',
    ONE_ROW_ADDED: 'oneRowAdded',
    MORE_THAN_ONE_ROW_ADDED: 'moreThanOneRowAdded',
    ROWS_REMOVED: 'rowsRemoved',
    CONTENTS_CHANGED: 'contentsChanged'
});
